import { Form, Modal, Row } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import React from 'react';
import Button from './Button';
import { useForm } from 'antd/es/form/Form';
import { openNotificationWithIcon } from 'utils/notification';

interface Ipops {
  setReasonRefuse: (data: string) => void;
  modalRejectOpen: boolean;
  setModalRejectOpen: (data: boolean) => void;
}

export default function PopupReasonRefuse(Ipops: Ipops) {
  const { setReasonRefuse, modalRejectOpen, setModalRejectOpen } = Ipops;
  const [form] = useForm();

  const onFinish = (values: any) => {
    const reason = values?.reasonRefuse;
    if (reason === undefined) {
      openNotificationWithIcon('error', 'Vui lòng nhập lý do');
    } else {
      setReasonRefuse(reason);
    }
  };

  return (
    <Modal
      open={modalRejectOpen}
      onCancel={() => {
        setModalRejectOpen(false);
      }}
      footer={null}
      width={'50%'}
    >
      <p className="text-2xl font-bold pb-6 border-b-2 border-neutral-90">
        Từ chối phê duyệt
      </p>

      <div className="py-6">
        <Form layout="vertical" onFinish={onFinish} form={form}>
          <Form.Item label="Lý do" name="reasonRefuse">
            <TextArea
              name="reject_description"
              showCount
              maxLength={100}
              placeholder="Nhập lý do"
            />
          </Form.Item>

          <Row justify="end" style={{ marginTop: '40px' }}>
            <Button
              onClick={() => {
                setModalRejectOpen(false);
              }}
              customClass="text-neutral-50 mr-2"
              bgColor="white"
            >
              Huỷ
            </Button>
            <Button type="submit">Gửi yêu cầu</Button>
          </Row>
        </Form>
      </div>
    </Modal>
  );
}
